import { useNavigate } from "react-router-dom";
import { PurchaseOrdersPage as PurchaseOrdersPageView } from "@/components/PurchaseOrdersPage";

export function PurchaseOrdersPage() {
  const navigate = useNavigate();
  return <PurchaseOrdersPageView onSelect={(id) => navigate(`/purchase-orders/${id}`)} />;
}
